(function () {
    'use strict';
    angular.module('emarket.main.statics')
      .controller('StaticController', ['$scope', '$location', '$rootScope', function($scope, $location, $rootScope) {
          var vm = this;
          vm.list = {
              use:true,
              general:false,
              prices:false,
              security: false
          };
          vm.open = {};
          vm.showList = function(list) {
              list = list === 'precios' ? 'prices' : list;
              list = list === 'uso' ? 'use' : list;
              list = list === 'seguridad' ? 'security' : list;
              Object.keys(vm.list).forEach(function(key) {
                  vm.list[key] = false;
              });
              vm.list[list] = true;
          };
          vm.open[$location.search().t] = true;
          if($location.search().a) {
              vm.showList($location.search().a);
          }
          var ev = $rootScope.$on('$locationChangeSuccess', function() {
              vm.open = {};
              vm.open[$location.search().t] = true;
          });
          $scope.$on('$destroy', function() {
              ev();
          });
      }]);
}());
